$(".style-guide .tile").each(function (index) {
    var rgb = $(this).css("background-color");
    hex = rgb2hex(rgb);

    function rgb2hex(rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        function hex(x) {
            return ("0" + parseInt(x).toString(16)).slice(-2);
        }
        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }

    $('<p>' + hex + '</p><p>' + rgb + '</p>').appendTo(this);
});


//////////////////
// WEBPACK FOOTER
// ./public/js/lib/styleGuide.js
// module id = 79
// module chunks = 0